import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0af0c887&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./detail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./detail.vue?vue&type=custom&index=1&blockType=graphql"
if (typeof block1 === 'function') block1(component)
import block2 from "./detail.vue?vue&type=custom&index=2&blockType=fragments"
if (typeof block2 === 'function') block2(component)

export default component.exports